export enum statuses {
  INITIAL = "INITIAL",
  MODIFIED = "MODIFIED",
  ADDED = "ADDED",
  DELETED = "DELETED"
}
